import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { SuggestionComponent } from './suggestion-modal.component';

@NgModule({
  declarations: [
    SuggestionComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
  ],
  exports: [SuggestionComponent],
})
export class SuggestionModule {

}
